import { motion } from 'framer-motion';
import { ChevronDown, MessageCircle } from 'lucide-react';

const HERO_BG = "https://customer-assets.emergentagent.com/job_703a842f-a54d-49a9-b401-d9b355165d79/artifacts/c6pwjyep_ayahuasca%20amazon%20trip.png";

export const HeroSection = ({ whatsappLink }) => {
  const scrollToExperience = () => {
    const element = document.querySelector('#experience');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero-section" data-testid="hero-section">
      {/* Background Image */}
      <div
        className="hero-bg"
        style={{ backgroundImage: `url(${HERO_BG})` }}
      />
      
      {/* Gradient Overlay */}
      <div className="hero-overlay" />
      
      {/* Animated Lines */}
      <div className="animated-lines" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="font-accent text-egyptian-gold text-lg sm:text-xl mb-4 tracking-widest"
          >
            WELCOME TO THE SACRED JOURNEY
          </motion.p>

          <h1 className="font-heading font-bold text-5xl sm:text-6xl md:text-7xl lg:text-8xl uppercase tracking-tight mb-6">
            <span className="block text-white">Discover the</span>
            <span className="neon-gold">Ancient Wisdom</span>
            <span className="block text-white">of Amazonia</span>
          </h1>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="font-body text-gray-300 text-lg sm:text-xl max-w-3xl mx-auto mb-10 leading-relaxed"
          >
            Experience a transformative ayahuasca journey in the heart of the Amazon rainforest. 
            Guided by qualified professionals in a safe, sacred environment where ancient traditions 
            meet modern understanding.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.8 }}
            className="flex flex-col sm:flex-row gap-4 justify-center items-center"
          >
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-btn text-lg"
              data-testid="hero-whatsapp-btn"
            >
              <MessageCircle className="w-6 h-6" />
              Begin Your Journey
            </a>
            
            <button
              onClick={scrollToExperience}
              className="cta-btn"
              data-testid="hero-learn-more-btn"
            >
              Learn More
            </button>
          </motion.div>
        </motion.div>

        {/* Scroll Indicator */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 1.2 }}
          className="absolute bottom-10 left-1/2 transform -translate-x-1/2 cursor-pointer"
          onClick={scrollToExperience}
          data-testid="scroll-indicator"
        >
          <motion.div
            animate={{ y: [0, 10, 0] }}
            transition={{ duration: 1.5, repeat: Infinity }}
            className="text-neon-cyan"
          >
            <ChevronDown className="w-8 h-8" />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
